import { createFileRoute, redirect } from "@tanstack/react-router";
import { sitzungQuery } from "@/auth";
import { KalkulationEinstellungen } from "@/pages/team/KalkulationEinstellungen";

/**
 * Die Stammdaten des Angebotsrechners (Personen, Fixkosten, Parameter,
 * Bausteine, Vorlagen) — Inhaber-Sache wie die Einstellungen selbst; das
 * Backend weist Mitglieder mit 403 ab.
 */
export const Route = createFileRoute("/_angemeldet/_mitarbeiter/einstellungen_/kalkulation")({
	beforeLoad: async ({ context }) => {
		const sitzung = await context.queryClient.ensureQueryData(sitzungQuery);
		if (sitzung?.teamRolle !== "inhaber") {
			throw redirect({ to: "/team" });
		}
	},
	component: KalkulationEinstellungen,
});
